import { api } from './api';

// Define a service using a base URL and expected endpoints
export const roleApi = api.injectEndpoints({
  reducerPath: 'roleApi',
  tagTypes: ['Roles'],
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => ({
        url: `/api/administration/roles`,
        method: 'GET'
      }),
      providesTags: ['Roles']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRolesQuery } = roleApi;
